import {WidgetType, widgetTypeIcon as icon} from "../models/WidgetType";

export const WidgetTypeIcon = "tfWidgetTypeIcon";

/** @ngInject */
export function widgetTypeIcon() {
    return function(type: WidgetType | null): string {
        if (type == null) {
            return "";
        } else {
            return icon(type);
        }
    }
}